<ui-grid [data]="data$ | async"
          [loading]="loading$ | async"
          [selectable]="false">
    <ui-grid-column [sortable]="false"
                    [title]="'transaction_details_grid_status' | translate"
                    property="status"
                    minWidth="5"
                    width="10%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('TransactionStatus_' + entry.status | translate) as statusText">
                <span [matTooltip]="statusText">
                    {{ statusText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transaction_details_grid_revision' | translate"
                    property="reviewStatus"
                    width="10%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('ReviewStatus_' + entry.reviewStatus | translate) as reviewStatusText">
                <span [matTooltip]="reviewStatusText">
                    {{ reviewStatusText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transaction_details_grid_deadline' | translate"
                    property="dueDate"
                    width="10%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #dueDateFormat
                           [matTooltip]="dueDateFormat?.dataset['title']"
                           [date]="entry.dueDate">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transaction_details_grid_retry_number' | translate"
                    property="retryNumber"
                    width="10%">
    </ui-grid-column>
    <ui-grid-column [title]="'transaction_details_grid_postpone' | translate"
                    [sortable]="false"
                    property="deferDate"
                    width="10%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #deferDateFormat
                           [matTooltip]="deferDateFormat?.dataset['title']"
                           [date]="entry.deferDate">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'transaction_details_grid_started' | translate"
                    property="startProcessing"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #startProcessFormat
                           [matTooltip]="startProcessFormat?.dataset['title']"
                           [date]="entry.startProcessing"
                           contentType="relative">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'transaction_details_grid_ended' | translate"
                    property="endProcessing"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #endProcessFormat
                           [matTooltip]="endProcessFormat?.dataset['title']"
                           [date]="entry.endProcessing"
                           contentType="relative">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [sortable]="true"
                    [title]="'transaction_details_grid_robot' | translate"
                    property="robot.name"
                    width="10%">
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transaction_details_grid_exception' | translate"
                    property="processingExceptionType"
                    width="10%">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.processingExceptionType">
                <ng-container *ngLet="('ProcessingExceptionType_' + entry.processingExceptionType) | translate
                              as processingExeptionText">
                    <span [matTooltip]="processingExeptionText">
                        {{ processingExeptionText }}
                    </span>
                </ng-container>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
